import { useEffect, useState } from 'react'
import { Segment, Input,Icon, Grid, Loader,Button, Popup } from 'semantic-ui-react'
import { getClinicas,deleteClinica, getReport } from '../../../../api/Orion/clinica';
import { ModalBasic,PaginationTable, Reports, FiltersOrionClinica, getPermissionsSecondary } from '../../../../components/Common';
import { useHistory } from "react-router-dom";
import { ListadoClinicas } from '../../../../components/Admin/Orion';
import { HeaderPage } from '../../../../components/Admin';
import { toast } from 'react-toastify'
import "./AbmAdmin.scss"
import { getPermissions } from '../../../../components/Common';
import { useAuth, useNotification } from '../../../../hooks';
import { animateScroll as scroll } from 'react-scroll'
import { addHash } from '../../../../api/Common/report';

export  function ClinicaOrionList() {
	const {auth} = useAuth()
    const [clinicas,setClinicas] = useState([])
    const [loading,setLoading] = useState(true)
    const [showModal,setShowModal] = useState(false)
    const [titleModal,setTitleModal] = useState(null)
    const [dataModal,setDataModal] = useState(null)
    const [contentModal,setContentModal] = useState(null)
    const [refetch, setRefetch] = useState(false)
	const [activePage, setActivePage] = useState(1);
	const [countPage, setCountPage] = useState(1);
	const [searchActive,setSearchActive] = useState("")
	const [filtersActive,setFiltersActive] = useState("")
	const [openFilter,setOpenFilter] = useState(false)
	const {startInterval} = useNotification()

	const limitPagination = 10
    const history = useHistory()
	const fetchClinicas = async (request = null) =>{
		setLoading(true)
		const clinicas = await getClinicas(request)
		setClinicas(clinicas.results)
		setCountPage(clinicas.count)
		setLoading(false)
		
	} 
    useEffect(()=>{
		scroll.scrollToTop();
		let filtrosExistentes = sessionStorage.getItem('orion_clinicas_filters')
		let searchExistentes = sessionStorage.getItem('orion_clinicas_search')
		if(searchExistentes){
			setSearchActive(searchExistentes)
			setFiltersActive(filtrosExistentes || "")
			fetchClinicas(
				filtrosExistentes !== ""
					? `page=1&paginate=true&search=${searchExistentes}&${filtrosExistentes}`
					: `page=1&paginate=true&search=${searchExistentes}`
			);
		} else if(filtrosExistentes){
			setFiltersActive(filtrosExistentes)
			fetchClinicas(`page=1&paginate=true&${filtrosExistentes}`); 
		} else {
			fetchClinicas(`page=1&paginate=true`); 
		}
    },[refetch])
	
    const onRefetch = () => setRefetch((prev) => !prev);
	const openCloseModal = ()=>{
		
		setShowModal((prev)=>!prev)
	}
   	const onDeleteClinica =  async(clinica)=>{
		setContentModal(<p>Desea eliminar clínica {clinica.clinica_nombre} ?</p>)
		setTitleModal("Eliminar clínica")
		setShowModal(true)
		setDataModal(clinica.id)
    

  	}
  	const openConfirmModal = async(id)=>{
		try {
			let response = await deleteClinica(id)
		
			toast.success(response.data)
			setShowModal(false)
			onRefetch()
		} catch (error) {
			console.error("Error en ClinicaOrionList:", error)
		} 
  	}
  	const crearClinica = (id) => {
    	history.push(`/admin/clinica_orion/crear`);
  	}

  	const onEditClinica = (clinica) => {
		history.push(`/admin/clinica_orion/edit/id/${clinica.id}`);
  	}
	const onShowClinica = (clinica) => {
		history.push(`/admin/clinica_orion/show/id/${clinica.id}`);
  	}

	const onReports = async()=> {
		let queryParams = `${filtersActive}`;

		if (searchActive !== "") {
			queryParams = `search=${searchActive}&` + queryParams;
		}

		let response = await getReport(queryParams)
		
		if (!response){

		}else{
			addHash(response.hash)
			startInterval()
		} 
	}

	/*  ##################### INICIO FUNCIONALIDAD FILTROS ##############################*/
	
	const openConfirmModalFilters = (formData)=>{
		let respuesta_final = []
		
		let provincia_filter = ""
		if(formData.clinica_provincia !== undefined && formData.clinica_provincia.length > 0){
			provincia_filter = `clinica_provincia=${formData.clinica_provincia.join(",")}`
			respuesta_final.push(provincia_filter)
		}
		
		let localidad_filter = ""
		if(formData.clinica_localidad !== undefined && formData.clinica_localidad.length > 0){
			localidad_filter = `clinica_localidad=${formData.clinica_localidad.join(",")}`
			respuesta_final.push(localidad_filter)
		}

		let convenio_filter = ""
		if(formData.clinica_convenio !== undefined && formData.clinica_convenio !== ''){
			convenio_filter = `clinica_convenio=${formData.clinica_convenio}`
			respuesta_final.push(convenio_filter)
		}

		let camara_filter = ""
		if(formData.clinica_camara !== undefined && formData.clinica_camara !== ''){
			camara_filter = `clinica_camara=${formData.clinica_camara}`
			respuesta_final.push(camara_filter)
		}

		let guardia_filter = ""
		if(formData.clinica_guardia !== undefined && formData.clinica_guardia !== ''){
			guardia_filter = `clinica_guardia=${formData.clinica_guardia}`
			respuesta_final.push(guardia_filter)
		}

		let renovacion_filter = ""
		if(formData.clinica_renovacion !== undefined && formData.clinica_renovacion !== ''){
			renovacion_filter = `clinica_renovacion=${formData.clinica_renovacion}`
			respuesta_final.push(renovacion_filter)
		}

		let request = `page=1&paginate=true`
		if(searchActive !== "")
			request += `&search=${searchActive}` 
		if(respuesta_final.length > 0)
			request += `&${respuesta_final.join('&')}`

		fetchClinicas(request); 
		sessionStorage.setItem('orion_clinicas_filters',respuesta_final.join('&'))
		setFiltersActive(respuesta_final.join('&'))
		setOpenFilter((prev)=>!prev)
		setLoading(true)
		setActivePage(1)
	}

	const openCloseModalFilters = ()=>{
		setOpenFilter((prev)=>!prev)
	}
	
	const openClearFilters = () =>{
		fetchClinicas(`page=1&paginate=true`); 
		setFiltersActive("")
		sessionStorage.removeItem('orion_clinicas_filters')
		setOpenFilter((prev)=>!prev)
		setLoading(true)
		setActivePage(1)
		onRefetch()
	}

	const onFilters = ()=> {
		setOpenFilter(true)
	}
	
	/*  ##################### FIN FILTROS ##############################*/

  	const onSearch =  (e) => {
		const value = e.target.value
		setSearchActive(value)
		sessionStorage.setItem('orion_clinicas_search', value)
		let request = `page=1&paginate=true&search=${value}`
		if(filtersActive !== "")
			request += `&${filtersActive}`
    	fetchClinicas(request); 
		setActivePage(1)
  	}
  	
	const onChange = (e, pageInfo) => {
		let request = `page=${pageInfo.activePage.toString()}&paginate=true`

		// Logica de search
		if(searchActive !== "")
			request += `&search=${searchActive}` 
		
		// Logica de filtros
		if(filtersActive !== "")
			request += `&${filtersActive}` 
		
    	fetchClinicas(request); 

		setActivePage(pageInfo.activePage);
		
	};

	const BotonFiltros = () =>{
		return(getPermissionsSecondary("clinica_provincia",auth,'filters','orion') ? (
			<Popup 
				content='Ver filtros' 
				trigger={
					<Button  
						onClick={onFilters} 
						icon={<Icon name='filter' className='color_search' inverted circular />} 
						inverted 
					/>
				}
			/>
		):(<Grid.Column computer={1} mobile={16} tablet={8}  ></Grid.Column>))
	}
  return (
    <div>
		
		<HeaderPage title="Clínicas" btnTitle="Agregar clínica" btnClick={crearClinica} permitionName="add_clinica"/>
		
		
		   <Grid as={Segment} className='segment_search'>
				<Grid.Row >
					<Grid.Column computer={3} mobile={16} tablet={16}>  
						<Input 
							fluid
							
						icon={<Icon name='search' className='color_search' inverted circular />} 
						className="input_search"  
						inverted 
						placeholder='Buscar...' 
						value={searchActive}
						onChange={onSearch}
					/>
					</Grid.Column>
					<Grid.Column computer={1} mobile={16} tablet={16}>
						<BotonFiltros />
					</Grid.Column>
					<Grid.Column computer={10} mobile={16} tablet={16}>
						<Reports confirmReports={onReports} />
					</Grid.Column>
					<br></br>
					<Grid.Column computer={2} mobile={16} tablet={16}>
					{getPermissions("add_clinica",auth) && (
						<Button circular basic positive onClick={crearClinica}>
							Agregar clínica
						</Button>
            )}
					</Grid.Column>

			
			
			</Grid.Row>
			</Grid>
		   
      <Grid>
        <Grid.Row>
          <Grid.Column computer={16}>
        
          </Grid.Column>
        </Grid.Row>
      </Grid>

	  {loading ? (
		<Loader active inline="centered">
			Cargando...
		</Loader>
	  ):(
		<ListadoClinicas 
		clinicas={clinicas} 
		onDeleteClinica={onDeleteClinica}
		onEditClinica={onEditClinica}
		onShowClinica={onShowClinica}
		countPage={countPage}
		pagination={
			<PaginationTable 
				clinicas={clinicas} 
				onChange={onChange}
				activePage={activePage}
				countPage={countPage}
				
				limitPagination={limitPagination}
			/>
		}
    />
  		)}

      <ModalBasic 
      show={showModal} 
      size="small" 
      title={titleModal} 
      children={contentModal}
      onClose={openCloseModal}
      onConfirm={openConfirmModal}
	  dataModal={dataModal}
      />

      <FiltersOrionClinica
        show={openFilter}
        onClose={openCloseModalFilters}
        onConfirm={openConfirmModalFilters}
        onClear={openClearFilters}
        auth={auth}
        type="orion"
      />
    </div>
  )
}
